import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {
  BikeUI,		
//  Budget,
//  TotalUsers,
//  HowToUse,
//  Segment,
//  TotalProfit,
//  LatestSales,
//  UsersByDevice,
//  LatestProducts,
//  LatestOrders
} from './Tab';

import _ from 'lodash';
import axios from 'axios';
import auth from '../../utils/auth';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  tab: {
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '4px 4px 0 0' 
  }, 
  tabPanel: {
  	padding: '16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px'
  }
}));

const AnalyzerTab = () => {
  const classes = useStyles();

  const extraInfo = auth.getExtraInfo() ? auth.getExtraInfo() : {pretest : 'none'};
  const gears = JSON.parse(extraInfo.bikes_json);

  const [gearinfo, setGearinfo] = React.useState(gears[0]);
  const [gearTab, setGearTab ] = React.useState(0);
  
  const gearinfoDefault = {};
  gearinfoDefault.bike_kit_json = JSON.stringify({
    bike_type:"road_allround",
    bike_weight:8,
    crr:0.005,
    cda:0.32,
    rim_height:1,
    drivetrain:"ultegra",
    tire_product:"Clincher (Butyl tube)",
    tire_width:2,
    cadence:90,
    rider_pose:2,
    surface_select:2,
    company_name:'',
    powermeter:'',
  });

  useEffect(() => {	
		const getBikeKit = () => {
//      console.log(gearinfo.bike_kit_json);

 //      {"bike_type":"hybrid","bike_weight":8,"crr":0.007,"cda":0.289011,"rim_height":"1","drivetrain":"105","tire_product":"Clincher (Butyl tube)","tire_width":"2","cadence":"90","rider_pose":"0","surface_select":"2"}

//			const auth_str = 'Bearer '.concat((auth.getToken().token)); 
//      let geat_id = gears[gearTab].gear_id;

//      setCircle(true);
/*      
			axios.get(
				`${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/bikekit.php`, 
				{ 
					headers: { Authorization: auth_str }, 
					params: { 
						order:'get_bike_kit',
						gear_id: geat_id
					}
				}
			).then(async function (response) {
//        setCircle(false);
//        const data = response.data;
        setGearinfo(response.data);
//        ;
			});
*/      
		}	

    getBikeKit();

	}, [gearinfo, gearTab]);


  const handleGearTab = (event, newValue) => {
    setGearinfo(gears[newValue]);
    setGearTab(newValue);
  };   

  function TabList(props) {
		const gears = props.gears;

    let rows = Array();

    console.log(gears);

    if (gears.length > 0) {
      _.each(gears, function(item, i) {
        let g_id = item.g_id;
        let gear_id = item.gear_id; 
        let gear_name = item.gear_name;
        let gear_primary = item.gear_primary;
        let weight = item.weight;
        let company_name = item.company_name ? item.company_name : '';
        let powermeter = item.powermeter_name ? item.powermeter_name : '';
        
        let	d = { i, g_id, gear_id, gear_name, gear_primary, weight, company_name, powermeter };	
        
        rows.push(d);        
      });
    
      return (
        <Tabs
          value={gearTab}
          onChange={handleGearTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"          
        >
        {
          rows.map((row, i) => (							
            <Tab key={row.i} label={row.gear_name} />	
          ))
        }        
        </Tabs>
      );
    } else {
      return (
        <Tabs
          value={0}
          onChange={handleGearTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"          
        >
        {
          <Tab key={0} label={"My Bike"} />	
        }        
        </Tabs>
      );
    }
  }

  function BikeUIByGear(props) {    
    const index = props.gearTab; 

    //bike_kit_json 이 비어있을 경우 
    const gearinfo = gears[index]; 

    if (gears.length > 0) {

      if(typeof gearinfo.bike_kit_json !== 'undefined' && gearinfo.bike_kit_json !== "") {
        ;
      } else {
        gearinfo.bike_kit_json = JSON.stringify({
          bike_type:"road_allround",
          bike_weight:8,
          crr:0.005,
          cda:0.32,
          rim_height:1,
          drivetrain:"ultegra",
          tire_product:"Clincher (Butyl tube)",
          tire_width:2,
          cadence:90,
          rider_pose:2,
          surface_select:2,
          company_name:'',
          powermeter:'',
        });
      }

      //있는 경우 

      return (
        <BikeUI gearinfo={gearinfo} />
      );

    } else {

      //없는 경우 

      return (        
        <BikeUI gearinfo={gearinfoDefault} />
      );
    }
  }


  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className={classes.tab}>
        <TabList gears={gears} />
{/*
          <Tab label="따릉이" {...TabPress(2)} />
         <Tab label="PR 계산기" {...TabPress(2)} />
 		<Tab label="사이클링등급" {...TabPress(3)} />
          <Tab label="Item Five" {...TabPress(4)} />
          <Tab label="Item Six" {...TabPress(5)} />
          <Tab label="Item Seven" {...TabPress(6)} />
*/}
      </AppBar>
 			<Box className={classes.tabPanel}>
        {
          gearinfo ? 
          <BikeUIByGear gearinfo={gearinfo} gearTab={gearTab} />
          :
          <BikeUIByGear gearinfo={gearinfoDefault} gearTab={gearTab} />
        }
			</Box>
		</div>
  );

}

export default AnalyzerTab;